<template>
  <div>
    <navlist :navlist="about" :show='false' />
    <div class="layout">
      <div class="title">
        <h1>
          社区
          <br />文化
        </h1>
        <h2>{{local.name}}</h2>
      </div>
      <div class="main">
         <h3 style="text-align:center; ">{{title}}</h3>
         <div v-html="content"></div>
      </div>
      
    </div>
  </div>
</template>

<script>
import news from "../components/news";
import navlist from "../components/nav";
import {getArticleContent} from '../api/index'
export default {
  name:'culturedetail',
  components: {
    navlist,
    news
  },
  data() {
    return {
      about: [
        {
          path: "/culture/culture",
          name: "我们的节日"
        },
        {
          path: "/culture/festival",
          name: "文体活动"
        }
      ],
      id:this.$route.params.detail,
      local: {},
      content:'',
      title:''
    };
  },
  created() {
    
    this.showlocal(this.$route);
    this.getContent()
  },
  watch: {
    $route(to) {
      this.showlocal(to);
    }
  },
  methods: {
    showlocal(to) {
      const local = this.about.filter(item => {
        if(item.path.indexOf(to.params.id)>=0){
          return item
        }
      });
      this.local = local[0];
    },
    async getContent(){
      let {id} =this
      let {data} = await getArticleContent({id})
      
      this.content = data.data.content
      this.title = data.data.title
    }
  }
};
</script>

<style>
.width {
  width: 1380px;
  margin-top: 20px !important;
}
</style>